(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-promo-card"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('promo-card')) {
    customElements.define(
      'promo-card',
      class PromoCard extends HTMLElement {
        constructor() {
          super();
          this.onMove = this.onMove.bind(this);
          this.onLeave = this.onLeave.bind(this);
          this.render = this.render.bind(this);
          this.onVisibility = this.onVisibility.bind(this);
          this.onDragStart = this.onDragStart.bind(this);
          this.onDragMove = this.onDragMove.bind(this);
          this.onDragEnd = this.onDragEnd.bind(this);
          this.onDragClick = this.onDragClick.bind(this);
          this.onNativeDrag = this.onNativeDrag.bind(this);
          this.rx = 0;
          this.ry = 0;
          this.targetRx = 0;
          this.targetRy = 0;
          this.raf = null;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.stage = this.querySelector('[data-fpc-stage]');
          this.tilt = this.querySelector('[data-fpc-tilt]');
          this.deck = this.querySelector('[data-fpc-deck]');
          this.cards = Array.prototype.slice.call(
            this.querySelectorAll('[data-fpc-card]')
          );
          this.dotsWrap = this.querySelector('[data-fpc-dots]');

          this.setupReveal();
          this.setupTilt();
          this.setupDeck();
          this.setupDrag();
        }

        disconnectedCallback() {
          if (this.stage) {
            this.stage.removeEventListener('pointermove', this.onMove);
            this.stage.removeEventListener('pointerleave', this.onLeave);
          }
          if (this.deck) {
            this.deck.removeEventListener('pointerdown', this.onDragStart);
            this.deck.removeEventListener('pointermove', this.onDragMove);
            this.deck.removeEventListener('pointerup', this.onDragEnd);
            this.deck.removeEventListener('pointercancel', this.onDragEnd);
            this.deck.removeEventListener('click', this.onDragClick, true);
            this.deck.removeEventListener('dragstart', this.onNativeDrag);
          }
          if (this.observer) this.observer.disconnect();
          if (this.viewObserver) this.viewObserver.disconnect();
          if (this.raf) window.cancelAnimationFrame(this.raf);
          document.removeEventListener('visibilitychange', this.onVisibility);
          this.stopLoop();
        }

        /* Endless card deck ---------------------------------------------- */

        setupDeck() {
          if (!this.deck || this.cards.length === 0) return;

          this.index = 0;
          this.total = this.cards.length;

          this.buildDots();
          this.paint();

          var prev = this.querySelector('[data-fpc-prev]');
          var next = this.querySelector('[data-fpc-next]');

          if (prev) {
            prev.addEventListener(
              'click',
              function (event) {
                event.preventDefault();
                this.go(this.index - 1, true);
              }.bind(this)
            );
          }

          if (next) {
            next.addEventListener(
              'click',
              function (event) {
                event.preventDefault();
                this.go(this.index + 1, true);
              }.bind(this)
            );
          }

          if (this.total < 2) return;
          if (this.dataset.loop !== 'true') return;
          if (reduceMotion.matches) return;

          this.speed = (parseFloat(this.dataset.loopSpeed) || 4) * 1000;

          if (this.dataset.pauseHover === 'true' && this.stage) {
            this.stage.addEventListener(
              'pointerenter',
              function () {
                this.hovering = true;
                this.stopLoop();
              }.bind(this)
            );
            this.stage.addEventListener(
              'pointerleave',
              function () {
                this.hovering = false;
                this.startLoop();
              }.bind(this)
            );
          }

          document.addEventListener('visibilitychange', this.onVisibility);

          if ('IntersectionObserver' in window) {
            this.viewObserver = new IntersectionObserver(
              function (entries) {
                var entry = entries[0];
                if (!entry) return;
                this.inView = entry.isIntersecting;
                if (this.inView) {
                  this.startLoop();
                } else {
                  this.stopLoop();
                }
              }.bind(this),
              { threshold: 0.2 }
            );
            this.viewObserver.observe(this);
          } else {
            this.inView = true;
            this.startLoop();
          }
        }

        buildDots() {
          if (!this.dotsWrap || this.total < 2) return;
          this.dotsWrap.innerHTML = '';
          this.dots = [];

          for (var i = 0; i < this.total; i += 1) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'fpc-dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Show card ' + (i + 1));
            dot.addEventListener('click', this.go.bind(this, i, true));
            this.dotsWrap.appendChild(dot);
            this.dots.push(dot);
          }
        }

        go(index, fromUser, event) {
          if (event && event.preventDefault) event.preventDefault();
          if (this.total < 1) return;

          this.previous = this.index;
          this.index = ((index % this.total) + this.total) % this.total;
          this.paint();

          if (fromUser) {
            this.startLoop();
          }
        }

        paint() {
          var total = this.total;
          var index = this.index;
          var previous = this.previous;

          this.cards.forEach(function (card, i) {
            var offset = (i - index + total) % total;
            var pos;

            if (offset === 0) {
              pos = '0';
            } else if (i === previous) {
              pos = 'out';
            } else if (offset === 1) {
              pos = '1';
            } else if (offset === 2) {
              pos = '2';
            } else {
              pos = 'far';
            }

            card.dataset.pos = pos;
            card.setAttribute('aria-hidden', pos === '0' ? 'false' : 'true');
          });

          if (this.dots) {
            this.dots.forEach(function (dot, i) {
              var active = i === index;
              dot.classList.toggle('is-active', active);
              dot.setAttribute('aria-selected', active ? 'true' : 'false');
            });
          }
        }

        startLoop() {
          if (this.total < 2) return;
          if (this.dataset.loop !== 'true') return;
          if (reduceMotion.matches) return;
          if (this.hovering || document.hidden || this.inView === false) return;
          if (this.dragActive) return;

          this.stopLoop();
          this.timer = window.setInterval(
            function () {
              this.go(this.index + 1);
            }.bind(this),
            this.speed
          );
        }

        stopLoop() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        }

        onVisibility() {
          if (document.hidden) {
            this.stopLoop();
          } else {
            this.startLoop();
          }
        }

        /* Swipe and drag -------------------------------------------------- */

        setupDrag() {
          if (!this.deck) return;
          if (this.dataset.drag !== 'true') return;
          if (!this.total || this.total < 2) return;

          this.dragAxis = this.dataset.dragDirection === 'horizontal' ? 'x' : 'y';
          this.dragThreshold = parseFloat(this.dataset.dragThreshold) || 80;
          this.dragRotate = parseFloat(this.dataset.dragRotate);
          if (isNaN(this.dragRotate)) this.dragRotate = 8;
          this.dragFollow = (parseFloat(this.dataset.dragFollow) || 100) / 100;

          this.dragReady = false;
          this.dragActive = false;
          this.dragDelta = 0;

          this.deck.addEventListener('pointerdown', this.onDragStart);
          this.deck.addEventListener('pointermove', this.onDragMove, { passive: true });
          this.deck.addEventListener('pointerup', this.onDragEnd);
          this.deck.addEventListener('pointercancel', this.onDragEnd);
          this.deck.addEventListener('click', this.onDragClick, true);
          this.deck.addEventListener('dragstart', this.onNativeDrag);
        }

        onNativeDrag(event) {
          event.preventDefault();
        }

        activeCard() {
          return (
            this.deck.querySelector(".fpc-card--front[data-pos='0']") ||
            this.cards[this.index] ||
            null
          );
        }

        onDragStart(event) {
          if (this.total < 2) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          var card = this.activeCard();
          if (!card) return;

          this.dragCard = card;
          this.dragId = event.pointerId;
          this.startX = event.clientX;
          this.startY = event.clientY;
          this.dragDelta = 0;
          this.dragReady = true;
          this.dragActive = false;
        }

        onDragMove(event) {
          if (!this.dragReady) return;
          if (event.pointerId !== this.dragId) return;

          var dx = event.clientX - this.startX;
          var dy = event.clientY - this.startY;
          var vertical = this.dragAxis === 'y';
          var main = vertical ? dy : dx;
          var cross = vertical ? dx : dy;

          if (!this.dragActive) {
            if (Math.abs(main) < 6 && Math.abs(cross) < 6) return;

            /* The gesture went across the swipe axis — let the page have it */
            if (Math.abs(cross) > Math.abs(main)) {
              this.dragReady = false;
              return;
            }

            this.dragActive = true;
            this.stopLoop();
            this.classList.add('fpc--is-dragging');
            this.deck.classList.add('is-dragging');
            this.dragCard.classList.add('is-dragging');

            if (this.deck.setPointerCapture) {
              try {
                this.deck.setPointerCapture(event.pointerId);
              } catch (error) {
                /* pointer capture is optional */
              }
            }
          }

          this.dragDelta = main;

          var progress = Math.min(1, Math.abs(main) / this.dragThreshold);
          var spin = (-main / this.dragThreshold) * this.dragRotate;
          if (spin > this.dragRotate) spin = this.dragRotate;
          if (spin < -this.dragRotate) spin = -this.dragRotate;

          var moveX = vertical ? dx * 0.3 : dx * this.dragFollow;
          var moveY = vertical ? dy * this.dragFollow : dy * 0.3;

          this.dragCard.style.transform =
            'translate3d(' +
            moveX.toFixed(1) +
            'px, ' +
            moveY.toFixed(1) +
            'px, 60px) rotate(calc(var(--fpc-front-rotate) + ' +
            spin.toFixed(2) +
            'deg))';
          this.dragCard.style.opacity = Math.max(0.3, 1 - progress * 0.45).toFixed(3);

          this.deck.style.setProperty('--fpc-drag-progress', progress.toFixed(3));
        }

        onDragEnd(event) {
          if (event && event.pointerId !== this.dragId) return;

          var wasActive = this.dragActive;
          var delta = this.dragDelta;

          this.dragReady = false;
          this.dragActive = false;
          this.dragDelta = 0;

          if (this.deck.releasePointerCapture && event) {
            try {
              this.deck.releasePointerCapture(event.pointerId);
            } catch (error) {
              /* nothing to release */
            }
          }

          this.classList.remove('fpc--is-dragging');
          this.deck.classList.remove('is-dragging');
          this.deck.style.removeProperty('--fpc-drag-progress');

          if (this.dragCard) {
            this.dragCard.classList.remove('is-dragging');
            this.dragCard.style.removeProperty('transform');
            this.dragCard.style.removeProperty('opacity');
          }

          this.dragCard = null;

          if (!wasActive) return;

          this.suppressClick = true;
          window.setTimeout(
            function () {
              this.suppressClick = false;
            }.bind(this),
            300
          );

          if (Math.abs(delta) >= this.dragThreshold) {
            /* Up or left sends the card away, down or right brings one back */
            this.go(delta < 0 ? this.index + 1 : this.index - 1, true);
          } else {
            this.startLoop();
          }
        }

        onDragClick(event) {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }

        /* Tilt ----------------------------------------------------------- */

        setupTilt() {
          if (!this.stage || !this.tilt) return;
          if (this.dataset.tilt !== 'true') return;
          if (reduceMotion.matches) return;
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

          this.strength = parseFloat(this.dataset.tiltStrength);
          if (isNaN(this.strength) || this.strength <= 0) return;

          this.stage.addEventListener('pointermove', this.onMove, { passive: true });
          this.stage.addEventListener('pointerleave', this.onLeave, { passive: true });
        }

        onMove(event) {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          if (this.dragActive) return;

          var rect = this.stage.getBoundingClientRect();
          if (!rect.width || !rect.height) return;

          var px = (event.clientX - rect.left) / rect.width - 0.5;
          var py = (event.clientY - rect.top) / rect.height - 0.5;

          this.targetRy = px * this.strength * 2;
          this.targetRx = -py * this.strength * 2;

          this.tilt.classList.add('is-tilting');
          this.start();
        }

        onLeave() {
          this.targetRx = 0;
          this.targetRy = 0;
          this.tilt.classList.remove('is-tilting');
          this.start();
        }

        start() {
          if (this.raf) return;
          this.raf = window.requestAnimationFrame(this.render);
        }

        render() {
          this.rx += (this.targetRx - this.rx) * 0.14;
          this.ry += (this.targetRy - this.ry) * 0.14;

          this.tilt.style.setProperty('--fpc-rx', this.rx.toFixed(2) + 'deg');
          this.tilt.style.setProperty('--fpc-ry', this.ry.toFixed(2) + 'deg');

          var settled =
            Math.abs(this.targetRx - this.rx) < 0.02 &&
            Math.abs(this.targetRy - this.ry) < 0.02;

          if (settled) {
            this.raf = null;
            return;
          }

          this.raf = window.requestAnimationFrame(this.render);
        }

        /* Reveal --------------------------------------------------------- */

        setupReveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.fpc-animate')
          );
          if (!targets.length) return;

          if (!('IntersectionObserver' in window) || reduceMotion.matches) {
            this.revealAll();
            return;
          }

          this.observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(
                function (entry) {
                  if (!entry.isIntersecting) return;
                  entry.target.classList.add('fpc-animate--in');
                  this.observer.unobserve(entry.target);
                }.bind(this)
              );
            }.bind(this),
            { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
          );

          targets.forEach(
            function (el, i) {
              el.style.transitionDelay = i * 120 + 'ms';
              this.observer.observe(el);
            }.bind(this)
          );
        }

        revealAll() {
          Array.prototype.forEach.call(
            this.querySelectorAll('.fpc-animate'),
            function (el) {
              el.classList.add('fpc-animate--in');
            }
          );
        }
      }
    );
  }

  function refresh(target) {
    if (!target) return;
    Array.prototype.forEach.call(
      target.querySelectorAll('promo-card'),
      function (el) {
        if (typeof el.revealAll === 'function') el.revealAll();
      }
    );
  }

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var host = event.target.closest('promo-card');
    var card = event.target.closest('[data-fpc-card]');
    if (!host || !card || typeof host.go !== 'function') return;
    host.stopLoop();
    host.go(parseInt(card.dataset.index, 10) || 0);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var host = event.target.closest('promo-card');
    if (host && typeof host.startLoop === 'function') host.startLoop();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isTouch() {
    return !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  if (!customElements.get('reels-feed')) {
    customElements.define(
      'reels-feed',
      class ReelsFeed extends HTMLElement {
        constructor() {
          super();
          this.onScroll = this.onScroll.bind(this);
          this.onResize = this.onResize.bind(this);
          this.next = this.next.bind(this);
          this.prev = this.prev.bind(this);
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onLightboxKey = this.onLightboxKey.bind(this);
          this.closeLightbox = this.closeLightbox.bind(this);
          this.lightboxNext = this.lightboxNext.bind(this);
          this.lightboxPrev = this.lightboxPrev.bind(this);
          this.tick = this.tick.bind(this);
          this.onVisibility = this.onVisibility.bind(this);
          this.ticking = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.track = this.querySelector('[data-irf-track]');
          if (!this.track) return;

          this.cards = Array.prototype.slice.call(
            this.querySelectorAll('[data-irf-card]')
          );
          this.slides = Array.prototype.slice.call(
            this.track.querySelectorAll('.irf-slide')
          );

          this.isSlider = this.dataset.slider === 'true';
          this.autoplayMode = this.dataset.autoplayMode || 'off';
          this.startMuted = this.dataset.muted === 'true';
          this.clickAction = this.dataset.click || 'none';
          this.rewind = this.dataset.rewind === 'true';
          this.dragEnabled = this.dataset.drag === 'true';
          this.carouselAutoplay = this.dataset.carouselAutoplay === 'true';
          this.speed = (parseFloat(this.dataset.carouselSpeed) || 5) * 1000;
          this.pauseHover = this.dataset.pauseHover === 'true';

          this.setupCards();
          this.setupReveal();

          if (this.isSlider) this.setupSlider();
          if (this.clickAction === 'lightbox') this.setupLightbox();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          document.removeEventListener('keydown', this.onLightboxKey);
          document.removeEventListener('visibilitychange', this.onVisibility);
          document.body.classList.remove('irf-lock');
          this.stopAutoplay();
          if (this.revealObserver) this.revealObserver.disconnect();
          if (this.playObserver) this.playObserver.disconnect();
        }

        /* ---------------------------------------------------------------
           Cards
           --------------------------------------------------------------- */

        setupCards() {
          this.cards.forEach(
            function (card) {
              var video = card.querySelector('[data-irf-video]');
              var sound = card.querySelector('[data-irf-sound]');
              var toggle = card.querySelector('[data-irf-toggle]');
              var open = card.querySelector('[data-irf-open]');

              if (video) {
                video.muted = this.startMuted;
                if (this.autoplayMode === 'hover' && !isTouch()) {
                  card.addEventListener('pointerenter', function () {
                    var attempt = video.play();
                    if (attempt && attempt.catch) attempt.catch(function () {});
                    card.classList.add('is-playing');
                  });
                  card.addEventListener('pointerleave', function () {
                    video.pause();
                    card.classList.remove('is-playing');
                  });
                }
              }

              if (sound && video) {
                sound.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
                sound.addEventListener(
                  'click',
                  function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    video.muted = !video.muted;
                    sound.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
                    if (!video.muted && video.paused) {
                      var attempt = video.play();
                      if (attempt && attempt.catch) attempt.catch(function () {});
                      card.classList.add('is-playing');
                    }
                  }
                );
              }

              if (toggle && video) {
                toggle.addEventListener('click', function (event) {
                  event.preventDefault();
                  if (video.paused) {
                    var attempt = video.play();
                    if (attempt && attempt.catch) attempt.catch(function () {});
                    card.classList.add('is-playing');
                  } else {
                    video.pause();
                    card.classList.remove('is-playing');
                  }
                });
              }

              if (open) {
                open.addEventListener(
                  'click',
                  function (event) {
                    event.preventDefault();
                    if (this.dragMoved) return;
                    this.openLightbox(parseInt(card.dataset.index, 10) || 0);
                  }.bind(this)
                );
              }
            }.bind(this)
          );

          if (this.autoplayMode === 'inview') this.setupInView();
        }

        setupInView() {
          if (!('IntersectionObserver' in window)) return;

          this.playObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                var card = entry.target;
                var video = card.querySelector('[data-irf-video]');
                if (!video) return;

                if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                  var attempt = video.play();
                  if (attempt && attempt.catch) attempt.catch(function () {});
                  card.classList.add('is-playing');
                } else {
                  video.pause();
                  card.classList.remove('is-playing');
                }
              });
            },
            { threshold: [0, 0.6] }
          );

          this.cards.forEach(
            function (card) {
              this.playObserver.observe(card);
            }.bind(this)
          );
        }

        pauseAllVideos() {
          this.cards.forEach(function (card) {
            var video = card.querySelector('[data-irf-video]');
            if (video && !video.paused) video.pause();
            card.classList.remove('is-playing');
          });
        }

        /* ---------------------------------------------------------------
           Slider
           --------------------------------------------------------------- */

        setupSlider() {
          this.prevBtns = Array.prototype.slice.call(
            this.querySelectorAll('[data-irf-prev]')
          );
          this.nextBtns = Array.prototype.slice.call(
            this.querySelectorAll('[data-irf-next]')
          );
          this.dotsWrap = this.querySelector('[data-irf-dots]');
          this.progressBar = this.querySelector('[data-irf-progress]');
          this.currentEl = this.querySelector('[data-irf-current]');

          this.prevBtns.forEach(
            function (btn) {
              btn.addEventListener('click', this.prev);
            }.bind(this)
          );
          this.nextBtns.forEach(
            function (btn) {
              btn.addEventListener('click', this.next);
            }.bind(this)
          );

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('keydown', this.onKeyDown);
          window.addEventListener('resize', this.onResize, { passive: true });

          if (this.dragEnabled) {
            this.classList.add('irf--drag');
            this.track.addEventListener('pointerdown', this.onPointerDown);
          }

          this.buildDots();
          this.measure();
          this.update();

          if (this.carouselAutoplay && !reduceMotion.matches) this.startAutoplay();
        }

        measure() {
          if (!this.slides.length) return;

          var first = this.slides[0];
          var second = this.slides[1];

          this.step = second
            ? second.getBoundingClientRect().left - first.getBoundingClientRect().left
            : first.getBoundingClientRect().width;

          if (!this.step || this.step < 1) this.step = 1;

          this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.lastIndex = Math.max(0, Math.round(this.maxScroll / this.step));
        }

        buildDots() {
          if (!this.dotsWrap) return;
          this.measure();
          this.dotsWrap.innerHTML = '';
          this.dots = [];

          var total = this.lastIndex + 1;
          if (total < 2) return;

          for (var i = 0; i < total; i += 1) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'irf-dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', this.goToIndex.bind(this, i));
            this.dotsWrap.appendChild(dot);
            this.dots.push(dot);
          }
        }

        goToIndex(index, event) {
          if (event) event.preventDefault();
          this.pauseFromUser();
          this.measure();
          this.track.scrollTo({
            left: Math.min(index * this.step, this.maxScroll),
            behavior: 'smooth'
          });
        }

        next(event) {
          if (event) {
            event.preventDefault();
            this.pauseFromUser();
          }
          this.measure();

          if (this.track.scrollLeft >= this.maxScroll - 2) {
            if (this.rewind) this.track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          this.track.scrollBy({ left: this.step, behavior: 'smooth' });
        }

        prev(event) {
          if (event) {
            event.preventDefault();
            this.pauseFromUser();
          }
          this.measure();

          if (this.track.scrollLeft <= 2) {
            if (this.rewind) {
              this.track.scrollTo({ left: this.maxScroll, behavior: 'smooth' });
            }
            return;
          }
          this.track.scrollBy({ left: -this.step, behavior: 'smooth' });
        }

        onKeyDown(event) {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.next(event);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.prev(event);
          }
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(
            function () {
              this.ticking = false;
              this.update();
            }.bind(this)
          );
        }

        onResize() {
          this.measure();
          this.buildDots();
          this.update();
        }

        update() {
          if (!this.track) return;
          if (!this.step) this.measure();

          var scrolled = this.track.scrollLeft;
          var index = Math.round(scrolled / this.step);
          if (index < 0) index = 0;
          if (index > this.lastIndex) index = this.lastIndex;

          var atStart = scrolled <= 2;
          var atEnd = scrolled >= this.maxScroll - 2;
          var rewind = this.rewind;

          if (this.prevBtns) {
            this.prevBtns.forEach(function (btn) {
              btn.disabled = atStart && !rewind;
            });
          }
          if (this.nextBtns) {
            this.nextBtns.forEach(function (btn) {
              btn.disabled = atEnd && !rewind;
            });
          }

          if (this.dots && this.dots.length) {
            this.dots.forEach(function (dot, i) {
              var active = i === index;
              dot.classList.toggle('is-active', active);
              dot.setAttribute('aria-selected', active ? 'true' : 'false');
            });
          }

          if (this.progressBar) {
            var ratio = this.maxScroll > 0 ? scrolled / this.maxScroll : 0;
            var visible = this.track.clientWidth / this.track.scrollWidth;
            var width = Math.max(visible * 100, 10);
            this.progressBar.style.width = width + '%';
            this.progressBar.style.transform =
              'translateX(' + ratio * ((100 / width) * 100 - 100) + '%)';
          }

          if (this.currentEl) this.currentEl.textContent = String(index + 1);
        }

        /* Drag ----------------------------------------------------------- */

        onPointerDown(event) {
          if (event.pointerType !== 'mouse') return;
          this.dragging = true;
          this.dragMoved = false;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.pauseFromUser();

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          var delta = event.clientX - this.startX;
          if (Math.abs(delta) > 5) {
            this.dragMoved = true;
            event.preventDefault();
          }
          this.track.scrollLeft = this.startScroll - delta;
        }

        onPointerUp(event) {
          if (!this.dragging) return;
          this.dragging = false;
          this.track.classList.remove('is-dragging');
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);

          if (this.dragMoved && event) {
            var link = event.target.closest ? event.target.closest('a') : null;
            if (link) {
              var block = function (clickEvent) {
                clickEvent.preventDefault();
                clickEvent.stopPropagation();
                link.removeEventListener('click', block, true);
              };
              link.addEventListener('click', block, true);
              window.setTimeout(function () {
                link.removeEventListener('click', block, true);
              }, 60);
            }
          }

          this.measure();
          var index = Math.round(this.track.scrollLeft / this.step);
          this.track.scrollTo({
            left: Math.min(Math.max(index, 0) * this.step, this.maxScroll),
            behavior: 'smooth'
          });

          window.setTimeout(
            function () {
              this.dragMoved = false;
            }.bind(this),
            80
          );
        }

        /* Carousel autoplay ---------------------------------------------- */

        startAutoplay() {
          this.stopAutoplay();
          this.timer = window.setInterval(this.tick, this.speed);

          if (this.pauseHover) {
            this.addEventListener('pointerenter', this.stopAutoplay.bind(this));
            this.addEventListener('pointerleave', this.resumeAutoplay.bind(this));
          }
          this.addEventListener('focusin', this.stopAutoplay.bind(this));
          document.addEventListener('visibilitychange', this.onVisibility);
        }

        tick() {
          this.measure();
          if (this.track.scrollLeft >= this.maxScroll - 2) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }
          this.track.scrollBy({ left: this.step, behavior: 'smooth' });
        }

        stopAutoplay() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        }

        resumeAutoplay() {
          if (!this.carouselAutoplay || this.userPaused || reduceMotion.matches) return;
          if (this.timer) return;
          this.timer = window.setInterval(this.tick, this.speed);
        }

        pauseFromUser() {
          this.userPaused = true;
          this.stopAutoplay();
        }

        onVisibility() {
          if (document.hidden) {
            this.stopAutoplay();
            this.pauseAllVideos();
          } else {
            this.resumeAutoplay();
          }
        }

        /* ---------------------------------------------------------------
           Lightbox
           --------------------------------------------------------------- */

        setupLightbox() {
          this.lightbox = this.querySelector('[data-irf-lightbox]');
          if (!this.lightbox) return;

          this.stage = this.lightbox.querySelector('[data-irf-stage]');
          this.meta = this.lightbox.querySelector('[data-irf-meta]');
          this.lbPrev = this.lightbox.querySelector('[data-irf-lb-prev]');
          this.lbNext = this.lightbox.querySelector('[data-irf-lb-next]');

          Array.prototype.forEach.call(
            this.lightbox.querySelectorAll('[data-irf-close]'),
            function (el) {
              el.addEventListener('click', this.closeLightbox);
            }.bind(this)
          );

          if (this.lbPrev) this.lbPrev.addEventListener('click', this.lightboxPrev);
          if (this.lbNext) this.lbNext.addEventListener('click', this.lightboxNext);

          this.playable = this.cards.filter(function (card) {
            return card.dataset.lightType && card.dataset.lightType !== 'none';
          });
        }

        openLightbox(index) {
          if (!this.lightbox) return;

          var card = this.cards[index];
          if (!card) return;

          this.lbIndex = this.playable.indexOf(card);
          if (this.lbIndex < 0) this.lbIndex = 0;

          this.pauseAllVideos();
          this.stopAutoplay();

          this.lightbox.hidden = false;
          document.body.classList.add('irf-lock');
          document.addEventListener('keydown', this.onLightboxKey);
          this.renderLightbox();

          var close = this.lightbox.querySelector('.irf-lightbox__close');
          if (close) close.focus();
        }

        renderLightbox() {
          var card = this.playable[this.lbIndex];
          if (!card || !this.stage) return;

          this.stage.innerHTML = '';
          if (this.meta) this.meta.innerHTML = '';

          var type = card.dataset.lightType;
          var node;

          if (type === 'youtube' && card.dataset.yt) {
            node = document.createElement('iframe');
            node.src =
              'https://www.youtube.com/embed/' +
              card.dataset.yt +
              '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
            node.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            node.setAttribute('allowfullscreen', '');
            node.setAttribute('title', card.dataset.caption || 'Reel');
          } else if (type === 'vimeo' && card.dataset.vm) {
            node = document.createElement('iframe');
            node.src =
              'https://player.vimeo.com/video/' +
              card.dataset.vm +
              '?autoplay=1&playsinline=1&dnt=1';
            node.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
            node.setAttribute('allowfullscreen', '');
            node.setAttribute('title', card.dataset.caption || 'Reel');
          } else if (card.dataset.src) {
            node = document.createElement('video');
            node.src = card.dataset.src;
            node.controls = true;
            node.autoplay = true;
            node.loop = true;
            node.playsInline = true;
            if (card.dataset.poster) node.poster = card.dataset.poster;
            node.setAttribute('aria-label', card.dataset.caption || 'Reel');
          }

          if (node) {
            this.stage.appendChild(node);
            if (node.tagName === 'VIDEO') {
              var attempt = node.play();
              if (attempt && attempt.catch) {
                attempt.catch(function () {
                  node.muted = true;
                  var retry = node.play();
                  if (retry && retry.catch) retry.catch(function () {});
                });
              }
            }
          }

          if (this.meta) {
            if (card.dataset.handle) {
              var handle = document.createElement('span');
              handle.className = 'irf-lightbox__handle';
              handle.textContent = card.dataset.handle;
              this.meta.appendChild(handle);
            }
            if (card.dataset.caption) {
              var caption = document.createElement('span');
              caption.className = 'irf-lightbox__caption';
              caption.textContent = card.dataset.caption;
              this.meta.appendChild(caption);
            }
            if (card.dataset.link) {
              var link = document.createElement('a');
              link.className = 'irf-lightbox__link';
              link.href = card.dataset.link;
              link.textContent = card.dataset.linkLabel || 'View';
              this.meta.appendChild(link);
            }
          }

          if (this.lbPrev) this.lbPrev.disabled = this.playable.length < 2;
          if (this.lbNext) this.lbNext.disabled = this.playable.length < 2;
        }

        lightboxNext(event) {
          if (event) event.preventDefault();
          if (this.playable.length < 2) return;
          this.lbIndex = (this.lbIndex + 1) % this.playable.length;
          this.renderLightbox();
        }

        lightboxPrev(event) {
          if (event) event.preventDefault();
          if (this.playable.length < 2) return;
          this.lbIndex =
            (this.lbIndex - 1 + this.playable.length) % this.playable.length;
          this.renderLightbox();
        }

        closeLightbox(event) {
          if (event) event.preventDefault();
          if (!this.lightbox || this.lightbox.hidden) return;

          this.lightbox.hidden = true;
          if (this.stage) this.stage.innerHTML = '';
          if (this.meta) this.meta.innerHTML = '';
          document.body.classList.remove('irf-lock');
          document.removeEventListener('keydown', this.onLightboxKey);
        }

        onLightboxKey(event) {
          if (event.key === 'Escape' || event.key === 'Esc') {
            event.preventDefault();
            this.closeLightbox();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.lightboxNext();
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.lightboxPrev();
          }
        }

        /* ---------------------------------------------------------------
           Reveal
           --------------------------------------------------------------- */

        setupReveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.irf-animate')
          );
          if (!targets.length) return;

          if (!('IntersectionObserver' in window) || reduceMotion.matches) {
            this.revealAll();
            return;
          }

          this.revealObserver = new IntersectionObserver(
            function (entries) {
              entries.forEach(
                function (entry) {
                  if (!entry.isIntersecting) return;
                  entry.target.classList.add('irf-animate--in');
                  this.revealObserver.unobserve(entry.target);
                }.bind(this)
              );
            }.bind(this),
            { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
          );

          targets.forEach(
            function (el, i) {
              el.style.transitionDelay = Math.min(i * 80, 400) + 'ms';
              this.revealObserver.observe(el);
            }.bind(this)
          );
        }

        revealAll() {
          Array.prototype.forEach.call(
            this.querySelectorAll('.irf-animate'),
            function (el) {
              el.classList.add('irf-animate--in');
            }
          );
        }
      }
    );
  }

  document.addEventListener('shopify:section:load', function (event) {
    Array.prototype.forEach.call(
      event.target.querySelectorAll('reels-feed'),
      function (el) {
        if (typeof el.revealAll === 'function') el.revealAll();
        if (typeof el.onResize === 'function') el.onResize();
      }
    );
  });

  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.forEach.call(
      event.target.querySelectorAll('reels-feed'),
      function (el) {
        if (typeof el.closeLightbox === 'function') el.closeLightbox();
      }
    );
    document.body.classList.remove('irf-lock');
  });

  document.addEventListener('shopify:block:select', function (event) {
    var feed = event.target.closest('reels-feed');
    if (!feed) return;
    if (typeof feed.revealAll === 'function') feed.revealAll();
    if (typeof feed.pauseFromUser === 'function') feed.pauseFromUser();

    var slide = event.target.closest('.irf-slide');
    if (slide && feed.track && feed.dataset.slider === 'true') {
      feed.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-cursor-effects"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ICONS = {
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15m-6-7 7 7-7 7"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13a1 1 0 0 0 1.5.87l11-6.5a1 1 0 0 0 0-1.74l-11-6.5A1 1 0 0 0 8 5.5z"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h13l-1.4 8.4a2 2 0 0 1-2 1.6H9.4a2 2 0 0 1-2-1.6L5.6 4.8H3"/><circle cx="9.5" cy="20" r="1.2"/><circle cx="16.5" cy="20" r="1.2"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 20.5s-7.5-4.7-7.5-9.9A4.3 4.3 0 0 1 12 7.7a4.3 4.3 0 0 1 7.5 2.9c0 5.2-7.5 9.9-7.5 9.9z"/></svg>',
    drag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 7 5 12l4 5M15 7l4 5-4 5"/></svg>'
  };

  function hexToRgb(value) {
    if (!value) return '18, 18, 18';
    var v = String(value).trim();

    if (v.indexOf('rgb') === 0) {
      var nums = v.replace(/[^0-9,.]/g, '').split(',');
      return [nums[0] || 0, nums[1] || 0, nums[2] || 0].join(', ');
    }

    v = v.replace('#', '');
    if (v.length === 3) {
      v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    }
    if (v.length < 6) return '18, 18, 18';

    return [
      parseInt(v.substring(0, 2), 16),
      parseInt(v.substring(2, 4), 16),
      parseInt(v.substring(4, 6), 16)
    ].join(', ');
  }

  function isLowEnd() {
    var cores = navigator.hardwareConcurrency;
    var memory = navigator.deviceMemory;
    if (typeof cores === 'number' && cores > 0 && cores < 4) return true;
    if (typeof memory === 'number' && memory > 0 && memory < 4) return true;
    if (navigator.connection && navigator.connection.saveData) return true;
    return false;
  }

  function clean(list) {
    if (!list) return '';
    return String(list)
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean)
      .join(',');
  }

  function safeMatch(el, selector) {
    if (!el || !selector || !el.closest) return null;
    try {
      return el.closest(selector);
    } catch (error) {
      return null;
    }
  }

  if (!customElements.get('magic-cursor')) {
    customElements.define(
      'magic-cursor',
      class MagicCursor extends HTMLElement {
        constructor() {
          super();
          this.frame = this.frame.bind(this);
          this.onMove = this.onMove.bind(this);
          this.onOver = this.onOver.bind(this);
          this.onOut = this.onOut.bind(this);
          this.onDown = this.onDown.bind(this);
          this.onUp = this.onUp.bind(this);
          this.onLeave = this.onLeave.bind(this);
          this.onEnter = this.onEnter.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onVisibility = this.onVisibility.bind(this);

          this.mouse = { x: -200, y: -200 };
          this.dot = { x: -200, y: -200, vx: 0, vy: 0 };
          this.ring = { x: -200, y: -200, vx: 0, vy: 0 };
          this.scale = 1;
          this.targetScale = 1;
          this.rotation = 0;
          this.targetRotation = 0;
          this.points = [];
          this.particles = [];
          this.magnet = null;
          this.magnetOffset = { x: 0, y: 0 };
          this.running = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          if (document.querySelector('.mc-root')) return;

          var script = this.querySelector('[data-mc-config]');
          if (!script) return;

          try {
            this.config = JSON.parse(script.textContent);
          } catch (error) {
            return;
          }

          if (!this.config.enabled) return;
          if (!this.allowedHere()) return;

          this.build();
          this.applyVars();
          this.bind();
          this.start();
        }

        disconnectedCallback() {
          this.destroy();
        }

        /* ---------------------------------------------------------------
           Environment checks
           --------------------------------------------------------------- */

        allowedHere() {
          var cfg = this.config;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return false;
          }
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            return false;
          }
          if (cfg.autoDisableLowEnd && isLowEnd()) return false;

          var width = window.innerWidth;
          if (width >= cfg.desktopMin) return cfg.devices.desktop;
          if (width >= cfg.tabletMin) return cfg.devices.tablet;
          return cfg.devices.mobile;
        }

        /* ---------------------------------------------------------------
           DOM
           --------------------------------------------------------------- */

        build() {
          var cfg = this.config;

          this.root = document.createElement('div');
          this.root.className = 'mc-root mc-root--' + cfg.style;
          this.root.setAttribute('aria-hidden', 'true');

          if (cfg.trail.enabled) {
            this.canvas = document.createElement('canvas');
            this.canvas.className = 'mc-canvas';
            this.ctx = this.canvas.getContext('2d');
            this.root.appendChild(this.canvas);
            this.sizeCanvas();
          }

          this.ringEl = document.createElement('div');
          this.ringEl.className = 'mc-ring';

          this.iconEl = document.createElement('span');
          this.iconEl.className = 'mc-icon';

          this.labelEl = document.createElement('span');
          this.labelEl.className = 'mc-label';

          this.ringEl.appendChild(this.iconEl);
          this.ringEl.appendChild(this.labelEl);

          this.dotEl = document.createElement('div');
          this.dotEl.className = 'mc-dot';

          this.root.appendChild(this.ringEl);
          this.root.appendChild(this.dotEl);
          document.body.appendChild(this.root);

          if (cfg.hideNative) {
            document.documentElement.classList.add('mc-hide-native');
          }

          if (cfg.label.uppercase) this.root.classList.add('mc-root--uppercase');
          if (cfg.neon) this.root.classList.add('mc-root--neon');
          if (cfg.glow > 0) this.root.classList.add('mc-root--glowing');
          if (cfg.blur > 0) this.root.classList.add('mc-root--blurred');
          if (cfg.motion.pulse) this.root.classList.add('mc-root--pulse');

          this.baseRing = cfg.ringSize;
          this.targetSelector = clean(cfg.targets);
          this.magneticSelector = clean(cfg.magnetic.selector);

          this.rules = (cfg.rules || []).filter(function (rule) {
            return rule.selector && rule.selector.trim();
          });

          this.presets = (cfg.presets || []).filter(function (preset) {
            return preset.on && preset.selector;
          });

          if (cfg.magnetic.enabled) {
            var extra = this.rules
              .filter(function (rule) {
                return rule.magnetic;
              })
              .map(function (rule) {
                return rule.selector;
              })
              .join(',');

            if (extra) {
              this.magneticSelector = this.magneticSelector
                ? this.magneticSelector + ',' + extra
                : extra;
            }
          }
        }

        applyVars() {
          var cfg = this.config;
          var s = this.root.style;

          s.setProperty('--mc-z', cfg.zIndex);
          s.setProperty('--mc-dot-size', cfg.dotSize + 'px');
          s.setProperty('--mc-ring-size', cfg.ringSize + 'px');
          s.setProperty('--mc-border', cfg.borderWidth + 'px');
          s.setProperty('--mc-radius', cfg.radius + '%');
          s.setProperty('--mc-dot-opacity', cfg.dotOpacity);
          s.setProperty('--mc-ring-opacity', cfg.ringOpacity);
          s.setProperty('--mc-blur', cfg.blur + 'px');
          s.setProperty('--mc-glow', cfg.glow + 'px');
          s.setProperty('--mc-blend', cfg.blendMode);
          s.setProperty('--mc-neon', cfg.neonColor);
          s.setProperty('--mc-glass-blur', cfg.glassBlur + 'px');
          s.setProperty('--mc-glass-opacity', cfg.glassOpacity);
          s.setProperty('--mc-glass-border', cfg.glassBorder);
          s.setProperty('--mc-glass-tint', hexToRgb(cfg.colors.secondary));

          s.setProperty('--mc-primary', cfg.colors.primary);
          s.setProperty('--mc-secondary', cfg.colors.secondary);
          s.setProperty('--mc-secondary-rgb', hexToRgb(cfg.colors.secondary));
          s.setProperty('--mc-hover', cfg.colors.hover);
          s.setProperty('--mc-click', cfg.colors.click);
          s.setProperty('--mc-text', cfg.colors.text);
          s.setProperty('--mc-icon-color', cfg.colors.icon);

          s.setProperty('--mc-text-size', cfg.label.size + 'px');
          s.setProperty('--mc-text-weight', cfg.label.weight);
          s.setProperty('--mc-text-spacing', cfg.label.spacing + 'em');
          s.setProperty('--mc-icon-size', cfg.label.iconSize + 'px');

          s.setProperty('--mc-trail-opacity', cfg.trail.opacity);
          s.setProperty('--mc-pulse-speed', cfg.motion.pulseSpeed + 's');
        }

        /* ---------------------------------------------------------------
           Events
           --------------------------------------------------------------- */

        bind() {
          document.addEventListener('pointermove', this.onMove, { passive: true });
          document.addEventListener('pointerover', this.onOver, { passive: true });
          document.addEventListener('pointerout', this.onOut, { passive: true });
          document.addEventListener('pointerdown', this.onDown, { passive: true });
          document.addEventListener('pointerup', this.onUp, { passive: true });
          document.addEventListener('mouseleave', this.onLeave);
          document.addEventListener('mouseenter', this.onEnter);
          document.addEventListener('visibilitychange', this.onVisibility);
          window.addEventListener('resize', this.onResize, { passive: true });
        }

        unbind() {
          document.removeEventListener('pointermove', this.onMove);
          document.removeEventListener('pointerover', this.onOver);
          document.removeEventListener('pointerout', this.onOut);
          document.removeEventListener('pointerdown', this.onDown);
          document.removeEventListener('pointerup', this.onUp);
          document.removeEventListener('mouseleave', this.onLeave);
          document.removeEventListener('mouseenter', this.onEnter);
          document.removeEventListener('visibilitychange', this.onVisibility);
          window.removeEventListener('resize', this.onResize);
        }

        onMove(event) {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          this.mouse.x = event.clientX;
          this.mouse.y = event.clientY;

          if (!this.visible) {
            this.visible = true;
            this.root.classList.remove('is-hidden');
          }

          if (this.config.trail.enabled) this.spawnTrail();
        }

        onOver(event) {
          var target = event.target;
          if (!target || target.nodeType !== 1) return;

          var match = this.resolve(target);
          if (!match) return;

          this.enterTarget(match);
        }

        onOut(event) {
          if (!this.current) return;
          var related = event.relatedTarget;
          if (related && this.current.el.contains(related)) return;
          this.leaveTarget();
        }

        onDown() {
          this.root.classList.add('is-clicking');
          this.clickScale = this.config.motion.clickScale;
          if (this.config.ripple.enabled) this.spawnRipple();
        }

        onUp() {
          this.root.classList.remove('is-clicking');
          this.clickScale = null;
        }

        onLeave() {
          if (!this.config.motion.hideIdle) return;
          this.visible = false;
          this.root.classList.add('is-hidden');
        }

        onEnter() {
          this.visible = true;
          this.root.classList.remove('is-hidden');
        }

        onVisibility() {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        }

        onResize() {
          if (this.config.trail.enabled) this.sizeCanvas();

          if (!this.allowedHere()) {
            this.destroy();
          }
        }

        /* ---------------------------------------------------------------
           Hover resolution
           --------------------------------------------------------------- */

        resolve(target) {
          var i;

          for (i = 0; i < this.rules.length; i += 1) {
            var rule = this.rules[i];
            var ruleEl = safeMatch(target, rule.selector);
            if (ruleEl) {
              return {
                el: ruleEl,
                text: ruleEl.getAttribute('data-cursor-text') || rule.text || '',
                icon: ruleEl.getAttribute('data-cursor-icon') || rule.icon || 'none',
                color: rule.color && rule.color.indexOf('rgba(0,0,0,0)') === -1 ? rule.color : '',
                scale: rule.scale || this.config.motion.hoverScale
              };
            }
          }

          for (i = 0; i < this.presets.length; i += 1) {
            var preset = this.presets[i];
            var presetEl = safeMatch(target, preset.selector);
            if (presetEl) {
              var icon = preset.icon === 'default' ? this.config.label.defaultIcon : preset.icon;
              return {
                el: presetEl,
                text: presetEl.getAttribute('data-cursor-text') || preset.text || '',
                icon: presetEl.getAttribute('data-cursor-icon') || icon || 'none',
                color: '',
                scale: this.config.motion.hoverScale
              };
            }
          }

          var generic = safeMatch(target, this.targetSelector);
          if (generic) {
            return {
              el: generic,
              text: generic.getAttribute('data-cursor-text') || '',
              icon: generic.getAttribute('data-cursor-icon') || this.config.label.defaultIcon || 'none',
              color: '',
              scale: this.config.motion.hoverScale
            };
          }

          return null;
        }

        enterTarget(match) {
          if (this.current && this.current.el === match.el) return;
          if (this.current) this.leaveTarget();

          this.current = match;
          this.root.classList.add('is-hovering');
          this.targetScale = match.scale;
          this.targetRotation = this.config.motion.rotation;

          if (match.color) {
            this.root.style.setProperty('--mc-hover', match.color);
          }

          if (match.text) {
            this.labelEl.textContent = match.text;
            this.root.classList.add('has-label');
          }

          if (match.icon && match.icon !== 'none' && ICONS[match.icon]) {
            this.iconEl.innerHTML = ICONS[match.icon];
            this.root.classList.add('has-icon');
          }

          if (match.text || (match.icon && match.icon !== 'none')) {
            this.ringEl.style.width = 'auto';
            this.ringEl.style.height = 'auto';
            this.ringEl.style.padding =
              Math.round(this.baseRing * 0.28) + 'px ' + Math.round(this.baseRing * 0.42) + 'px';
            this.ringEl.style.marginLeft = '0';
            this.ringEl.style.marginTop = '0';
            this.ringEl.style.transform += ' translate(-50%, -50%)';
            this.labelPadding = true;
            this.targetScale = 1;
          }

          if (this.config.magnetic.enabled && safeMatch(match.el, this.magneticSelector)) {
            this.magnet = safeMatch(match.el, this.magneticSelector);
            this.magnet.classList.add('mc-magnetic-el');
          }
        }

        leaveTarget() {
          this.current = null;
          this.root.classList.remove('is-hovering', 'has-label', 'has-icon');
          this.root.style.setProperty('--mc-hover', this.config.colors.hover);
          this.targetScale = 1;
          this.targetRotation = 0;
          this.labelEl.textContent = '';
          this.iconEl.innerHTML = '';

          if (this.labelPadding) {
            this.ringEl.style.width = '';
            this.ringEl.style.height = '';
            this.ringEl.style.padding = '';
            this.ringEl.style.marginLeft = '';
            this.ringEl.style.marginTop = '';
            this.labelPadding = false;
          }

          if (this.magnet) {
            this.releaseMagnet = this.magnet;
            this.magnet.classList.remove('mc-magnetic-el');
            this.magnet = null;
          }
        }

        /* ---------------------------------------------------------------
           Ripple
           --------------------------------------------------------------- */

        spawnRipple() {
          var cfg = this.config.ripple;
          var el = document.createElement('span');
          el.className = 'mc-ripple';
          el.style.setProperty('--mc-ripple-size', cfg.size + 'px');
          el.style.setProperty('--mc-ripple-width', cfg.width + 'px');
          el.style.setProperty('--mc-ripple-color', cfg.color);
          el.style.setProperty('--mc-ripple-duration', cfg.duration + 'ms');
          el.style.transform =
            'translate3d(' + this.mouse.x + 'px,' + this.mouse.y + 'px,0) scale(0.1)';

          this.root.appendChild(el);

          var x = this.mouse.x;
          var y = this.mouse.y;

          window.requestAnimationFrame(function () {
            el.style.transition =
              'transform ' + cfg.duration + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
            el.style.transform =
              'translate3d(' + x + 'px,' + y + 'px,0) scale(1)';
          });

          window.setTimeout(function () {
            if (el.parentNode) el.parentNode.removeChild(el);
          }, cfg.duration + 60);
        }

        /* ---------------------------------------------------------------
           Trail
           --------------------------------------------------------------- */

        sizeCanvas() {
          if (!this.canvas) return;
          var dpr = Math.min(window.devicePixelRatio || 1, 2);
          this.dpr = dpr;
          this.canvas.width = Math.floor(window.innerWidth * dpr);
          this.canvas.height = Math.floor(window.innerHeight * dpr);
          if (this.ctx) this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }

        spawnTrail() {
          var cfg = this.config.trail;

          if (cfg.type === 'line') {
            this.points.push({ x: this.mouse.x, y: this.mouse.y });
            if (this.points.length > cfg.count) this.points.shift();
            return;
          }

          if (this.particles.length >= cfg.count * 3) return;

          var count = cfg.type === 'sparkle' ? 2 : 1;

          for (var i = 0; i < count; i += 1) {
            this.particles.push({
              x: this.mouse.x,
              y: this.mouse.y,
              vx: (Math.random() - 0.5) * (cfg.type === 'smoke' ? 0.6 : 2),
              vy:
                cfg.type === 'smoke'
                  ? -Math.random() * 0.9 - 0.2
                  : (Math.random() - 0.5) * 2,
              life: 1,
              size: cfg.size * (0.5 + Math.random() * 0.8),
              rot: Math.random() * Math.PI
            });
          }
        }

        drawTrail() {
          if (!this.ctx) return;

          var cfg = this.config.trail;
          var ctx = this.ctx;
          var w = window.innerWidth;
          var h = window.innerHeight;

          ctx.clearRect(0, 0, w, h);

          if (cfg.type === 'line') {
            if (this.points.length < 2) return;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';

            for (var p = 1; p < this.points.length; p += 1) {
              var ratio = p / this.points.length;
              ctx.beginPath();
              ctx.strokeStyle = cfg.color;
              ctx.globalAlpha = ratio;
              ctx.lineWidth = cfg.size * ratio;
              ctx.moveTo(this.points[p - 1].x, this.points[p - 1].y);
              ctx.lineTo(this.points[p].x, this.points[p].y);
              ctx.stroke();
            }

            ctx.globalAlpha = 1;
            if (this.points.length > 1) this.points.shift();
            return;
          }

          var fade = cfg.fade * 0.15 + 0.008;
          var next = [];

          for (var i = 0; i < this.particles.length; i += 1) {
            var particle = this.particles[i];
            particle.x += particle.vx;
            particle.y += particle.vy;
            particle.life -= fade;

            if (particle.life <= 0) continue;

            ctx.globalAlpha = Math.max(particle.life, 0);

            if (cfg.type === 'sparkle') {
              ctx.save();
              ctx.translate(particle.x, particle.y);
              ctx.rotate(particle.rot + (1 - particle.life) * 2);
              ctx.fillStyle = particle.life > 0.5 ? cfg.color : cfg.color2;
              var s = particle.size * particle.life;
              ctx.beginPath();
              ctx.moveTo(0, -s);
              ctx.quadraticCurveTo(0, 0, s, 0);
              ctx.quadraticCurveTo(0, 0, 0, s);
              ctx.quadraticCurveTo(0, 0, -s, 0);
              ctx.quadraticCurveTo(0, 0, 0, -s);
              ctx.fill();
              ctx.restore();
            } else if (cfg.type === 'glow' || cfg.type === 'smoke') {
              var radius = particle.size * (cfg.type === 'smoke' ? 2 - particle.life : particle.life);
              var gradient = ctx.createRadialGradient(
                particle.x,
                particle.y,
                0,
                particle.x,
                particle.y,
                Math.max(radius, 0.1)
              );
              gradient.addColorStop(0, cfg.color);
              gradient.addColorStop(1, 'rgba(0,0,0,0)');
              ctx.fillStyle = gradient;
              ctx.beginPath();
              ctx.arc(particle.x, particle.y, Math.max(radius, 0.1), 0, Math.PI * 2);
              ctx.fill();
            } else {
              ctx.fillStyle = particle.life > 0.5 ? cfg.color : cfg.color2;
              ctx.beginPath();
              ctx.arc(
                particle.x,
                particle.y,
                Math.max(particle.size * particle.life * 0.5, 0.1),
                0,
                Math.PI * 2
              );
              ctx.fill();
            }

            next.push(particle);
          }

          ctx.globalAlpha = 1;
          this.particles = next;
        }

        /* ---------------------------------------------------------------
           Loop
           --------------------------------------------------------------- */

        start() {
          if (this.running || !this.root) return;
          this.running = true;
          this.raf = window.requestAnimationFrame(this.frame);
        }

        stop() {
          this.running = false;
          if (this.raf) window.cancelAnimationFrame(this.raf);
        }

        frame() {
          if (!this.running) return;

          var cfg = this.config;
          var motion = cfg.motion;

          if (motion.easing === 'instant') {
            this.dot.x = this.mouse.x;
            this.dot.y = this.mouse.y;
            this.ring.x = this.mouse.x;
            this.ring.y = this.mouse.y;
          } else if (motion.easing === 'spring') {
            this.spring(this.dot, motion.stiffness, motion.damping);
            this.spring(this.ring, motion.stiffness * 0.6, motion.damping);
          } else {
            this.dot.x += (this.mouse.x - this.dot.x) * motion.dotSpeed;
            this.dot.y += (this.mouse.y - this.dot.y) * motion.dotSpeed;
            this.ring.x += (this.mouse.x - this.ring.x) * motion.ringSpeed;
            this.ring.y += (this.mouse.y - this.ring.y) * motion.ringSpeed;
          }

          var target = this.clickScale ? this.targetScale * this.clickScale : this.targetScale;
          this.scale += (target - this.scale) * 0.18;
          this.rotation += (this.targetRotation - this.rotation) * 0.14;

          this.dotEl.style.transform =
            'translate3d(' + this.dot.x + 'px,' + this.dot.y + 'px,0)';

          var ringTransform =
            'translate3d(' + this.ring.x + 'px,' + this.ring.y + 'px,0) scale(' +
            this.scale.toFixed(3) + ') rotate(' + this.rotation.toFixed(2) + 'deg)';

          if (this.labelPadding) {
            ringTransform += ' translate(-50%, -50%)';
          }

          this.ringEl.style.transform = ringTransform;

          if (cfg.magnetic.enabled) this.updateMagnet();
          if (cfg.trail.enabled) this.drawTrail();

          this.raf = window.requestAnimationFrame(this.frame);
        }

        spring(state, stiffness, damping) {
          state.vx = (state.vx + (this.mouse.x - state.x) * stiffness) * damping;
          state.vy = (state.vy + (this.mouse.y - state.y) * stiffness) * damping;
          state.x += state.vx;
          state.y += state.vy;
        }

        updateMagnet() {
          var cfg = this.config.magnetic;

          if (this.magnet) {
            var rect = this.magnet.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var cy = rect.top + rect.height / 2;
            var dx = this.mouse.x - cx;
            var dy = this.mouse.y - cy;
            var distance = Math.sqrt(dx * dx + dy * dy);

            if (distance < cfg.radius + Math.max(rect.width, rect.height) / 2) {
              this.magnetOffset.x += (dx * cfg.strength - this.magnetOffset.x) * 0.2;
              this.magnetOffset.y += (dy * cfg.strength - this.magnetOffset.y) * 0.2;
              this.magnet.style.transform =
                'translate3d(' +
                this.magnetOffset.x.toFixed(2) + 'px,' +
                this.magnetOffset.y.toFixed(2) + 'px,0)';
            }
            return;
          }

          if (this.releaseMagnet) {
            this.magnetOffset.x += (0 - this.magnetOffset.x) * cfg.release;
            this.magnetOffset.y += (0 - this.magnetOffset.y) * cfg.release;

            this.releaseMagnet.style.transform =
              'translate3d(' +
              this.magnetOffset.x.toFixed(2) + 'px,' +
              this.magnetOffset.y.toFixed(2) + 'px,0)';

            if (
              Math.abs(this.magnetOffset.x) < 0.4 &&
              Math.abs(this.magnetOffset.y) < 0.4
            ) {
              this.releaseMagnet.style.transform = '';
              this.releaseMagnet = null;
              this.magnetOffset.x = 0;
              this.magnetOffset.y = 0;
            }
          }
        }

        /* ---------------------------------------------------------------
           Teardown
           --------------------------------------------------------------- */

        destroy() {
          this.stop();
          this.unbind();

          if (this.root && this.root.parentNode) {
            this.root.parentNode.removeChild(this.root);
          }

          if (this.releaseMagnet) this.releaseMagnet.style.transform = '';
          if (this.magnet) this.magnet.style.transform = '';

          document.documentElement.classList.remove('mc-hide-native');
          this.root = null;
          this.initialized = false;
        }
      }
    );
  }

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('magic-cursor');
    if (el && typeof el.destroy === 'function') el.destroy();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value) {
    if (value < 0) return 0;
    if (value > 100) return 100;
    return value;
  }

  if (!customElements.get('before-after-compare')) {
    customElements.define(
      'before-after-compare',
      class BeforeAfterCompare extends HTMLElement {
        constructor() {
          super();
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onHoverMove = this.onHoverMove.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onIntersect = this.onIntersect.bind(this);
          this.dragging = false;
          this.touched = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.frame = this.querySelector('.bac-frame');
          this.knob = this.querySelector('[data-bac-knob]');
          if (!this.frame || !this.knob) return;

          this.vertical = this.dataset.orientation === 'vertical';
          this.mode = this.dataset.mode || 'both';
          this.start = parseFloat(this.dataset.start);
          if (isNaN(this.start)) this.start = 50;
          this.position = this.start;

          this.setPosition(this.start, true);

          this.frame.addEventListener('pointerdown', this.onPointerDown);
          this.knob.addEventListener('keydown', this.onKeyDown);

          if (this.usesHover()) {
            this.frame.addEventListener('pointermove', this.onHoverMove);
            this.frame.addEventListener('pointerleave', this.onPointerUp);
          }

          if (this.dataset.reveal === 'true' && !reduceMotion.matches) {
            this.setupReveal();
          }
        }

        disconnectedCallback() {
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
          if (this.observer) this.observer.disconnect();
          if (this.raf) window.cancelAnimationFrame(this.raf);
        }

        usesHover() {
          if (this.mode === 'hover') return true;
          if (this.mode !== 'both') return false;
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        }

        /* Position ----------------------------------------------------- */

        setPosition(value, silent) {
          var next = clamp(value);
          this.position = next;
          this.style.setProperty('--bac-pos', next.toFixed(2) + '%');
          if (this.knob) {
            this.knob.setAttribute('aria-valuenow', Math.round(next));
          }
          if (!silent) this.markTouched();
        }

        markTouched() {
          if (this.touched) return;
          this.touched = true;
          this.classList.add('is-touched');
        }

        positionFromEvent(event) {
          var rect = this.frame.getBoundingClientRect();
          if (!rect.width || !rect.height) return this.position;

          if (this.vertical) {
            return ((event.clientY - rect.top) / rect.height) * 100;
          }
          return ((event.clientX - rect.left) / rect.width) * 100;
        }

        /* Drag --------------------------------------------------------- */

        onPointerDown(event) {
          if (event.button !== undefined && event.button !== 0) return;
          if (this.mode === 'hover') return;

          this.stopReveal();
          this.dragging = true;
          this.frame.classList.add('is-dragging');
          this.setPosition(this.positionFromEvent(event));

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
          window.addEventListener('pointercancel', this.onPointerUp);

          if (event.pointerType !== 'mouse') event.preventDefault();
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          event.preventDefault();
          this.setPosition(this.positionFromEvent(event));
        }

        onPointerUp() {
          this.dragging = false;
          if (this.frame) this.frame.classList.remove('is-dragging');
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          window.removeEventListener('pointercancel', this.onPointerUp);
        }

        onHoverMove(event) {
          if (this.dragging) return;
          if (event.pointerType && event.pointerType !== 'mouse') return;
          this.stopReveal();
          this.setPosition(this.positionFromEvent(event));
        }

        /* Keyboard ----------------------------------------------------- */

        onKeyDown(event) {
          var step = event.shiftKey ? 10 : 2;
          var handled = true;

          switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
              this.setPosition(this.position - step);
              break;
            case 'ArrowRight':
            case 'ArrowUp':
              this.setPosition(this.position + step);
              break;
            case 'Home':
              this.setPosition(0);
              break;
            case 'End':
              this.setPosition(100);
              break;
            case 'PageDown':
              this.setPosition(this.position - 10);
              break;
            case 'PageUp':
              this.setPosition(this.position + 10);
              break;
            default:
              handled = false;
          }

          if (handled) {
            this.stopReveal();
            event.preventDefault();
          }
        }

        /* Reveal sweep -------------------------------------------------- */

        setupReveal() {
          if (!('IntersectionObserver' in window)) return;

          this.observer = new IntersectionObserver(this.onIntersect, {
            threshold: 0.35
          });
          this.observer.observe(this);
        }

        onIntersect(entries) {
          var entry = entries[0];
          if (!entry || !entry.isIntersecting) return;
          if (this.observer) this.observer.disconnect();
          if (this.touched) return;
          this.playReveal();
        }

        playReveal() {
          var self = this;
          var from = this.start;
          var keyframes = [from, Math.max(from - 26, 6), Math.min(from + 26, 94), from];
          var legDuration = 620;
          var startTime = null;
          var leg = 0;

          function ease(t) {
            return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          }

          function step(now) {
            if (self.revealStopped) return;
            if (startTime === null) startTime = now;

            var elapsed = now - startTime;
            var t = elapsed / legDuration;

            if (t >= 1) {
              t = 0;
              leg += 1;
              startTime = now;
              if (leg >= keyframes.length - 1) {
                self.setPosition(from, true);
                return;
              }
            }

            var a = keyframes[leg];
            var b = keyframes[leg + 1];
            self.setPosition(a + (b - a) * ease(t), true);
            self.raf = window.requestAnimationFrame(step);
          }

          this.raf = window.requestAnimationFrame(step);
        }

        stopReveal() {
          this.revealStopped = true;
          if (this.raf) window.cancelAnimationFrame(this.raf);
        }
      }
    );
  }

  /* Scroll reveal for the section ------------------------------------- */

  function revealSection(root) {
    var targets = Array.prototype.slice.call(
      root.querySelectorAll('.bac-animate')
    );
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      targets.forEach(function (el) {
        el.classList.add('bac-animate--in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bac-animate--in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index * 90, 450) + 'ms';
      observer.observe(el);
    });
  }

  function initSections(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.bac-section'),
      function (section) {
        if (section.dataset.bacReady === 'true') return;
        section.dataset.bacReady = 'true';
        revealSection(section);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    Array.prototype.forEach.call(
      event.target.querySelectorAll('.bac-animate'),
      function (el) {
        el.classList.add('bac-animate--in');
      }
    );
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-brand-story-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('brand-story-timeline')) {
    customElements.define(
      'brand-story-timeline',
      class BrandStoryTimeline extends HTMLElement {
        constructor() {
          super();
          this.handleReveal = this.handleReveal.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.updateProgress = this.updateProgress.bind(this);
          this.ticking = false;
          this.inView = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.timeline = this.querySelector('[data-bst-timeline]');
          this.fill = this.querySelector('[data-bst-fill]');

          this.reveal();
          this.setupProgress();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.viewObserver) this.viewObserver.disconnect();
          window.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.handleScroll);
        }

        /* Reveal ------------------------------------------------------- */

        reveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.bst-animate')
          );
          if (!targets.length) return;

          if (!('IntersectionObserver' in window) || reduceMotion.matches) {
            this.revealAll();
            return;
          }

          this.observer = new IntersectionObserver(this.handleReveal, {
            rootMargin: '0px 0px -8% 0px',
            threshold: 0.12
          });

          targets.forEach(
            function (el) {
              this.observer.observe(el);
            }.bind(this)
          );
        }

        handleReveal(entries) {
          entries.forEach(
            function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('bst-animate--in');
              this.observer.unobserve(entry.target);
            }.bind(this)
          );
        }

        revealAll() {
          Array.prototype.forEach.call(
            this.querySelectorAll('.bst-animate'),
            function (el) {
              el.classList.add('bst-animate--in');
            }
          );
        }

        /* Scroll progress ---------------------------------------------- */

        setupProgress() {
          if (!this.fill || !this.timeline) return;
          if (reduceMotion.matches) {
            this.timeline.style.setProperty('--bst-progress', '1');
            return;
          }

          window.addEventListener('scroll', this.handleScroll, {
            passive: true
          });
          window.addEventListener('resize', this.handleScroll, {
            passive: true
          });

          if ('IntersectionObserver' in window) {
            this.viewObserver = new IntersectionObserver(
              function (entries) {
                this.inView = entries[0] ? entries[0].isIntersecting : false;
                if (this.inView) this.handleScroll();
              }.bind(this),
              { rootMargin: '120px 0px 120px 0px' }
            );
            this.viewObserver.observe(this.timeline);
          } else {
            this.inView = true;
          }

          this.updateProgress();
        }

        handleScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(this.updateProgress);
        }

        updateProgress() {
          this.ticking = false;
          if (!this.timeline || !this.fill) return;

          var rect = this.timeline.getBoundingClientRect();
          if (!rect.height) return;

          var anchor = window.innerHeight * 0.62;
          var value = (anchor - rect.top) / rect.height;

          if (value < 0) value = 0;
          if (value > 1) value = 1;

          this.timeline.style.setProperty('--bst-progress', value.toFixed(4));
        }
      }
    );
  }

  function revealIn(target) {
    if (!target) return;
    var sections = target.querySelectorAll('brand-story-timeline');
    Array.prototype.forEach.call(sections, function (el) {
      if (typeof el.revealAll === 'function') el.revealAll();
      if (typeof el.handleScroll === 'function') el.handleScroll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealIn(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    revealIn(event.target.closest('.shopify-section') || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-image-with-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('image-with-text-premium')) {
    customElements.define(
      'image-with-text-premium',
      class ImageWithTextPremium extends HTMLElement {
        constructor() {
          super();
          this.handleReveal = this.handleReveal.bind(this);
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.reveal();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        reveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.iwt-animate')
          );
          if (!targets.length) return;

          targets.forEach(function (el, index) {
            if (el.classList.contains('iwt-animate--media')) return;
            el.style.transitionDelay = Math.min(index * 80, 480) + 'ms';
          });

          if (!('IntersectionObserver' in window) || reduceMotion.matches) {
            this.revealAll();
            return;
          }

          this.observer = new IntersectionObserver(this.handleReveal, {
            rootMargin: '0px 0px -6% 0px',
            threshold: 0.08
          });

          targets.forEach(
            function (el) {
              this.observer.observe(el);
            }.bind(this)
          );
        }

        handleReveal(entries) {
          entries.forEach(
            function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('iwt-animate--in');
              this.observer.unobserve(entry.target);
            }.bind(this)
          );
        }

        revealAll() {
          Array.prototype.forEach.call(
            this.querySelectorAll('.iwt-animate'),
            function (el) {
              el.classList.add('iwt-animate--in');
            }
          );
        }
      }
    );
  }

  function revealIn(target) {
    if (!target) return;
    var sections = target.querySelectorAll('image-with-text-premium');
    Array.prototype.forEach.call(sections, function (el) {
      if (typeof el.revealAll === 'function') el.revealAll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealIn(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    revealIn(event.target.closest('.shopify-section') || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-rich-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('rich-text-premium')) {
    customElements.define(
      'rich-text-premium',
      class RichTextPremium extends HTMLElement {
        constructor() {
          super();
          this.handleReveal = this.handleReveal.bind(this);
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.reveal();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        reveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.rt-animate')
          );
          if (!targets.length) return;

          targets.forEach(function (el, index) {
            el.style.transitionDelay = Math.min(index * 90, 540) + 'ms';
          });

          if (!('IntersectionObserver' in window) || reduceMotion.matches) {
            targets.forEach(function (el) {
              el.classList.add('rt-animate--in');
            });
            return;
          }

          this.observer = new IntersectionObserver(this.handleReveal, {
            rootMargin: '0px 0px -6% 0px',
            threshold: 0.1
          });

          targets.forEach(
            function (el) {
              this.observer.observe(el);
            }.bind(this)
          );
        }

        handleReveal(entries) {
          entries.forEach(
            function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('rt-animate--in');
              this.observer.unobserve(entry.target);
            }.bind(this)
          );
        }

        revealAll() {
          Array.prototype.forEach.call(
            this.querySelectorAll('.rt-animate'),
            function (el) {
              el.classList.add('rt-animate--in');
            }
          );
        }
      }
    );
  }

  function revealIn(target) {
    if (!target) return;
    var sections = target.querySelectorAll('rich-text-premium');
    Array.prototype.forEach.call(sections, function (el) {
      if (typeof el.revealAll === 'function') el.revealAll();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealIn(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    revealIn(event.target.closest('.shopify-section') || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-ugc-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!customElements.get('ugc-slider')) {
    customElements.define(
      'ugc-slider',
      class UgcSlider extends HTMLElement {
        constructor() {
          super();
          this.onScroll = this.onScroll.bind(this);
          this.onResize = this.onResize.bind(this);
          this.next = this.next.bind(this);
          this.prev = this.prev.bind(this);
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.onVisibility = this.onVisibility.bind(this);
          this.tick = this.tick.bind(this);
          this.index = 0;
          this.ticking = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.track = this.querySelector("[data-igf-track]");
          if (!this.track) return;

          this.slides = Array.prototype.slice.call(
            this.track.querySelectorAll('.igf-slide')
          );
          if (!this.slides.length) return;

          this.prevBtns = Array.prototype.slice.call(
            this.querySelectorAll('[data-igf-prev]')
          );
          this.nextBtns = Array.prototype.slice.call(
            this.querySelectorAll('[data-igf-next]')
          );
          this.dotsWrap = this.querySelector('[data-igf-dots]');
          this.progressBar = this.querySelector('[data-igf-progress]');
          this.currentEl = this.querySelector('[data-igf-current]');

          this.loop = this.dataset.loop === 'true';
          this.dragEnabled = this.dataset.drag === 'true';
          this.pauseHover = this.dataset.pauseHover === 'true';
          this.autoplay = this.dataset.autoplay === 'true';
          this.speed = (parseFloat(this.dataset.autoplaySpeed) || 4) * 1000;

          this.prevBtns.forEach(
            function (btn) {
              btn.addEventListener('click', this.prev);
            }.bind(this)
          );
          this.nextBtns.forEach(
            function (btn) {
              btn.addEventListener('click', this.next);
            }.bind(this)
          );

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('keydown', this.onKeyDown);
          window.addEventListener('resize', this.onResize, { passive: true });

          if (this.dragEnabled) {
            this.classList.add('igf--drag');
            this.track.addEventListener('pointerdown', this.onPointerDown);
          }

          this.buildDots();
          this.measure();
          this.update();
          this.setupReveal();

          if (this.autoplay && !reduceMotion.matches) this.startAutoplay();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);
          document.removeEventListener('visibilitychange', this.onVisibility);
          this.stopAutoplay();
          if (this.observer) this.observer.disconnect();
        }

        /* Measurements -------------------------------------------------- */

        measure() {
          if (!this.slides.length || !this.track) return;

          var first = this.slides[0];
          var second = this.slides[1];

          this.slideWidth = first.getBoundingClientRect().width;
          this.step = second
            ? second.getBoundingClientRect().left -
              first.getBoundingClientRect().left
            : this.slideWidth;

          if (!this.step || this.step < 1) this.step = this.slideWidth || 1;

          this.maxScroll = Math.max(
            0,
            this.track.scrollWidth - this.track.clientWidth
          );
          this.lastIndex = Math.max(0, Math.round(this.maxScroll / this.step));
        }

        buildDots() {
          if (!this.dotsWrap) return;
          this.measure();

          this.dotsWrap.innerHTML = '';
          this.dots = [];

          var total = this.lastIndex + 1;
          if (total < 2) return;

          for (var i = 0; i < total; i += 1) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'igf-dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.dataset.index = String(i);
            dot.addEventListener('click', this.goToIndex.bind(this, i));
            this.dotsWrap.appendChild(dot);
            this.dots.push(dot);
          }
        }

        /* Navigation ---------------------------------------------------- */

        goToIndex(index, event) {
          if (event) event.preventDefault();
          this.pauseFromUser();
          this.measure();
          var target = Math.min(index * this.step, this.maxScroll);
          this.track.scrollTo({ left: target, behavior: 'smooth' });
        }

        next(event) {
          if (event) {
            event.preventDefault();
            this.pauseFromUser();
          }
          this.measure();

          if (this.track.scrollLeft >= this.maxScroll - 2) {
            if (this.loop) {
              this.track.scrollTo({ left: 0, behavior: 'smooth' });
            }
            return;
          }

          this.track.scrollBy({ left: this.step, behavior: 'smooth' });
        }

        prev(event) {
          if (event) {
            event.preventDefault();
            this.pauseFromUser();
          }
          this.measure();

          if (this.track.scrollLeft <= 2) {
            if (this.loop) {
              this.track.scrollTo({ left: this.maxScroll, behavior: 'smooth' });
            }
            return;
          }

          this.track.scrollBy({ left: -this.step, behavior: 'smooth' });
        }

        onKeyDown(event) {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.next(event);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.prev(event);
          }
        }

        /* State --------------------------------------------------------- */

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(
            function () {
              this.ticking = false;
              this.update();
            }.bind(this)
          );
        }

        onResize() {
          this.measure();
          this.buildDots();
          this.update();
        }

        update() {
          if (!this.track) return;
          if (!this.step) this.measure();

          var scrolled = this.track.scrollLeft;
          var index = Math.round(scrolled / this.step);
          if (index < 0) index = 0;
          if (index > this.lastIndex) index = this.lastIndex;
          this.index = index;

          var atStart = scrolled <= 2;
          var atEnd = scrolled >= this.maxScroll - 2;

          this.prevBtns.forEach(function (btn) {
            btn.disabled = atStart && !this.loop;
          }, this);

          this.nextBtns.forEach(function (btn) {
            btn.disabled = atEnd && !this.loop;
          }, this);

          if (this.dots && this.dots.length) {
            this.dots.forEach(function (dot, i) {
              var active = i === index;
              dot.classList.toggle('is-active', active);
              dot.setAttribute('aria-selected', active ? 'true' : 'false');
            });
          }

          if (this.progressBar) {
            var ratio = this.maxScroll > 0 ? scrolled / this.maxScroll : 0;
            var visible = this.track.clientWidth / this.track.scrollWidth;
            var width = Math.max(visible * 100, 10);
            this.progressBar.style.width = width + '%';
            this.progressBar.style.transform =
              'translateX(' + ratio * ((100 / width) * 100 - 100) + '%)';
          }

          if (this.currentEl) {
            this.currentEl.textContent = String(index + 1);
          }
        }

        /* Drag ---------------------------------------------------------- */

        onPointerDown(event) {
          if (event.pointerType !== 'mouse') return;
          if (event.target.closest('a, button')) {
            this.pendingDrag = { x: event.clientX, y: event.clientY };
          }

          this.dragging = true;
          this.moved = 0;
          this.startX = event.clientX;
          this.startScroll = this.track.scrollLeft;
          this.track.classList.add('is-dragging');
          this.pauseFromUser();

          window.addEventListener('pointermove', this.onPointerMove);
          window.addEventListener('pointerup', this.onPointerUp);
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          var delta = event.clientX - this.startX;
          this.moved = Math.abs(delta);
          if (this.moved > 4) event.preventDefault();
          this.track.scrollLeft = this.startScroll - delta;
        }

        onPointerUp(event) {
          if (!this.dragging) return;
          this.dragging = false;
          this.track.classList.remove('is-dragging');

          window.removeEventListener('pointermove', this.onPointerMove);
          window.removeEventListener('pointerup', this.onPointerUp);

          if (this.moved > 6 && event) {
            var link = event.target.closest ? event.target.closest('a') : null;
            if (link) {
              var block = function (clickEvent) {
                clickEvent.preventDefault();
                clickEvent.stopPropagation();
                link.removeEventListener('click', block, true);
              };
              link.addEventListener('click', block, true);
              window.setTimeout(function () {
                link.removeEventListener('click', block, true);
              }, 60);
            }
          }

          this.snapToNearest();
        }

        snapToNearest() {
          this.measure();
          var index = Math.round(this.track.scrollLeft / this.step);
          var target = Math.min(Math.max(index, 0) * this.step, this.maxScroll);
          this.track.scrollTo({ left: target, behavior: 'smooth' });
        }

        /* Autoplay ------------------------------------------------------ */

        startAutoplay() {
          this.stopAutoplay();
          this.timer = window.setInterval(this.tick, this.speed);

          if (this.pauseHover) {
            this.addEventListener('pointerenter', this.stopAutoplay.bind(this));
            this.addEventListener('pointerleave', this.resumeAutoplay.bind(this));
          }

          this.addEventListener('focusin', this.stopAutoplay.bind(this));
          document.addEventListener('visibilitychange', this.onVisibility);
        }

        tick() {
          if (!this.track) return;
          this.measure();

          if (this.track.scrollLeft >= this.maxScroll - 2) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }

          this.track.scrollBy({ left: this.step, behavior: 'smooth' });
        }

        stopAutoplay() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        }

        resumeAutoplay() {
          if (!this.autoplay || this.userPaused || reduceMotion.matches) return;
          if (this.timer) return;
          this.timer = window.setInterval(this.tick, this.speed);
        }

        pauseFromUser() {
          this.userPaused = true;
          this.stopAutoplay();
        }

        onVisibility() {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.resumeAutoplay();
          }
        }

        /* Reveal -------------------------------------------------------- */

        setupReveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.igf-animate')
          );
          if (!targets.length) return;

          if (!('IntersectionObserver' in window) || reduceMotion.matches) {
            this.revealAll();
            return;
          }

          this.observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(
                function (entry) {
                  if (!entry.isIntersecting) return;
                  entry.target.classList.add('igf-animate--in');
                  this.observer.unobserve(entry.target);
                }.bind(this)
              );
            }.bind(this),
            { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
          );

          targets.forEach(
            function (el, i) {
              el.style.transitionDelay = Math.min(i * 110, 330) + 'ms';
              this.observer.observe(el);
            }.bind(this)
          );
        }

        revealAll() {
          Array.prototype.forEach.call(
            this.querySelectorAll('.igf-animate'),
            function (el) {
              el.classList.add('igf-animate--in');
            }
          );
        }
      }
    );
  }

  function refresh(target) {
    if (!target) return;
    Array.prototype.forEach.call(
      target.querySelectorAll('ugc-slider'),
      function (el) {
        if (typeof el.revealAll === 'function') el.revealAll();
        if (typeof el.onResize === 'function') el.onResize();
      }
    );
  }

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slider = event.target.closest('ugc-slider');
    if (!slider) return;
    if (typeof slider.revealAll === 'function') slider.revealAll();
    if (typeof slider.pauseFromUser === 'function') slider.pauseFromUser();

    var slide = event.target.closest('.igf-slide');
    if (!slide || !slider.track) return;
    slider.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  /* ------------------------------------------------------------------------
     Modal
     ------------------------------------------------------------------------ */

  if (!customElements.get('premium-video-modal')) {
    customElements.define(
      'premium-video-modal',
      class PremiumVideoModal extends HTMLElement {
        constructor() {
          super();
          this.onKeydown = this.onKeydown.bind(this);
          this.close = this.close.bind(this);
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.stage = this.querySelector('[data-pv-modal-stage]');
          this.template = this.querySelector('[data-pv-modal-template]');
          this.closers = this.querySelectorAll('[data-pv-close]');

          this.closers.forEach(
            function (el) {
              el.addEventListener('click', this.close);
            }.bind(this)
          );
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKeydown);
          document.body.classList.remove('pv-modal-open');
        }

        open(opener) {
          if (!this.stage || !this.template) return;

          this.opener = opener || null;
          this.stage.innerHTML = '';
          this.stage.appendChild(this.template.content.cloneNode(true));

          this.classList.add('pv-modal--open');
          document.body.classList.add('pv-modal-open');
          document.addEventListener('keydown', this.onKeydown);

          var player = this.stage.querySelector('[data-pv-player]');
          if (player && player.tagName === 'VIDEO') {
            var attempt = player.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(function () {
                player.muted = true;
                var retry = player.play();
                if (retry && typeof retry.catch === 'function') {
                  retry.catch(function () {});
                }
              });
            }
          }

          var closeBtn = this.querySelector('.pv-modal__close');
          if (closeBtn) closeBtn.focus();
        }

        close() {
          if (!this.classList.contains('pv-modal--open')) return;

          this.classList.remove('pv-modal--open');
          document.body.classList.remove('pv-modal-open');
          document.removeEventListener('keydown', this.onKeydown);

          if (this.stage) this.stage.innerHTML = '';

          if (this.opener && typeof this.opener.focus === 'function') {
            this.opener.focus();
          }
          this.opener = null;
        }

        onKeydown(event) {
          if (event.key === 'Escape' || event.key === 'Esc') {
            event.preventDefault();
            this.close();
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------------
     Video
     ------------------------------------------------------------------------ */

  if (!customElements.get('premium-video')) {
    customElements.define(
      'premium-video',
      class PremiumVideo extends HTMLElement {
        constructor() {
          super();
          this.handlePlayClick = this.handlePlayClick.bind(this);
          this.handleSoundClick = this.handleSoundClick.bind(this);
          this.handleIntersect = this.handleIntersect.bind(this);
          this.handleReveal = this.handleReveal.bind(this);
          this.activated = false;
        }

        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.videoType = this.dataset.videoType || 'none';
          this.playMode = this.dataset.playMode || 'inline';
          this.autoplay = this.dataset.autoplay === 'true';
          this.muted = this.dataset.muted === 'true';
          this.loop = this.dataset.loop === 'true';
          this.pauseOffscreen = this.dataset.pauseOffscreen === 'true';

          this.stage = this.querySelector('[data-pv-stage]');
          this.template = this.querySelector('[data-pv-template]');
          this.poster = this.querySelector('[data-pv-poster]');
          this.soundButton = this.querySelector('[data-pv-sound]');
          this.triggers = Array.prototype.slice.call(
            this.querySelectorAll('[data-pv-play]')
          );

          this.modal = this.dataset.modalId
            ? document.getElementById(this.dataset.modalId)
            : null;

          this.triggers.forEach(
            function (trigger) {
              trigger.addEventListener('click', this.handlePlayClick);
            }.bind(this)
          );

          if (this.soundButton) {
            this.soundButton.addEventListener('click', this.handleSoundClick);
          }

          this.setupReveal();

          if (this.videoType !== 'none') {
            this.setupPlaybackObserver();
          }
        }

        disconnectedCallback() {
          if (this.playbackObserver) this.playbackObserver.disconnect();
          if (this.revealObserver) this.revealObserver.disconnect();
          if (this.modal && typeof this.modal.close === 'function') {
            this.modal.close();
          }
        }

        /* --------------------------------------------------------------- */

        setupReveal() {
          var targets = Array.prototype.slice.call(
            this.querySelectorAll('.pv-animate')
          );
          if (!targets.length) return;

          if (
            !('IntersectionObserver' in window) ||
            prefersReducedMotion.matches
          ) {
            targets.forEach(function (el) {
              el.classList.add('pv-animate--in');
            });
            return;
          }

          this.revealObserver = new IntersectionObserver(this.handleReveal, {
            rootMargin: '0px 0px -8% 0px',
            threshold: 0.12
          });

          targets.forEach(
            function (el) {
              this.revealObserver.observe(el);
            }.bind(this)
          );
        }

        handleReveal(entries) {
          entries.forEach(
            function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('pv-animate--in');
              this.revealObserver.unobserve(entry.target);
            }.bind(this)
          );
        }

        /* --------------------------------------------------------------- */

        setupPlaybackObserver() {
          if (!('IntersectionObserver' in window)) {
            if (this.autoplay && this.playMode === 'inline') this.activate();
            return;
          }

          this.playbackObserver = new IntersectionObserver(
            this.handleIntersect,
            { threshold: [0, 0.25] }
          );
          this.playbackObserver.observe(this);
        }

        handleIntersect(entries) {
          var entry = entries[0];
          if (!entry) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            if (this.autoplay && this.playMode === 'inline') {
              this.activate(false);
            }
            return;
          }

          if (!entry.isIntersecting && this.pauseOffscreen) {
            this.pause();
          }
        }

        /* --------------------------------------------------------------- */

        handlePlayClick(event) {
          event.preventDefault();

          if (this.playMode === 'modal') {
            if (this.modal && typeof this.modal.open === 'function') {
              this.modal.open(event.currentTarget);
            }
            return;
          }

          this.activate(true);
        }

        activate(userInitiated) {
          if (this.videoType === 'none') return;

          if (this.activated) {
            this.play();
            return;
          }

          if (!this.template || !this.stage) return;

          this.stage.appendChild(this.template.content.cloneNode(true));
          this.activated = true;
          this.classList.add('pv--playing');

          this.player = this.stage.querySelector('[data-pv-player]');
          if (!this.player) return;

          if (this.player.tagName === 'VIDEO') {
            this.player.muted = this.muted;
            if (userInitiated && !this.autoplay && !this.muted) {
              this.player.muted = false;
            }
            this.play();
          }
        }

        play() {
          if (!this.player) return;

          if (this.player.tagName === 'VIDEO') {
            var attempt = this.player.play();
            if (attempt && typeof attempt.catch === 'function') {
              var player = this.player;
              attempt.catch(function () {
                player.muted = true;
                var retry = player.play();
                if (retry && typeof retry.catch === 'function') {
                  retry.catch(function () {});
                }
              });
            }
            return;
          }

          this.postToEmbed('play');
        }

        pause() {
          if (!this.player) return;

          if (this.player.tagName === 'VIDEO') {
            this.player.pause();
            return;
          }

          this.postToEmbed('pause');
        }

        postToEmbed(action) {
          if (!this.player || this.player.tagName !== 'IFRAME') return;
          if (!this.player.contentWindow) return;

          var provider = this.player.dataset.pvProvider;
          var message;

          if (provider === 'youtube') {
            message = JSON.stringify({
              event: 'command',
              func: action === 'play' ? 'playVideo' : 'pauseVideo',
              args: []
            });
            this.player.contentWindow.postMessage(
              message,
              'https://www.youtube.com'
            );
            return;
          }

          if (provider === 'vimeo') {
            message = JSON.stringify({ method: action });
            this.player.contentWindow.postMessage(
              message,
              'https://player.vimeo.com'
            );
          }
        }

        /* --------------------------------------------------------------- */

        handleSoundClick(event) {
          event.preventDefault();

          var isMuted = this.soundButton.getAttribute('aria-pressed') === 'true';
          var nextMuted = !isMuted;

          this.soundButton.setAttribute('aria-pressed', String(nextMuted));
          this.soundButton.setAttribute(
            'aria-label',
            nextMuted ? 'Turn sound on' : 'Turn sound off'
          );

          if (!this.player) return;

          if (this.player.tagName === 'VIDEO') {
            this.player.muted = nextMuted;
            if (!nextMuted && this.player.paused) this.play();
            return;
          }

          if (this.player.tagName !== 'IFRAME' || !this.player.contentWindow) {
            return;
          }

          var provider = this.player.dataset.pvProvider;

          if (provider === 'youtube') {
            this.player.contentWindow.postMessage(
              JSON.stringify({
                event: 'command',
                func: nextMuted ? 'mute' : 'unMute',
                args: []
              }),
              'https://www.youtube.com'
            );
            return;
          }

          if (provider === 'vimeo') {
            this.player.contentWindow.postMessage(
              JSON.stringify({ method: 'setVolume', value: nextMuted ? 0 : 1 }),
              'https://player.vimeo.com'
            );
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------------
     Theme editor support
     ------------------------------------------------------------------------ */

  function closeModalsIn(target) {
    if (!target) return;
    var modals = target.querySelectorAll('premium-video-modal');
    Array.prototype.forEach.call(modals, function (modal) {
      if (typeof modal.close === 'function') modal.close();
    });
  }

  function pauseVideosIn(target) {
    if (!target) return;
    var videos = target.querySelectorAll('premium-video');
    Array.prototype.forEach.call(videos, function (video) {
      if (typeof video.pause === 'function') video.pause();
    });
  }

  document.addEventListener('shopify:section:unload', function (event) {
    closeModalsIn(event.target);
    document.body.classList.remove('pv-modal-open');
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    closeModalsIn(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var video = event.target.querySelector('premium-video');
    if (video && video.dataset.autoplay === 'true') {
      if (typeof video.activate === 'function') video.activate(false);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    pauseVideosIn(event.target.closest('.shopify-section') || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
